import { render, staticRenderFns } from "./VacancyUnavailableChatMessage.htm?vue&type=template&id=ee6678bc&scoped=true&"
import script from "./VacancyUnavailableChatMessage.ts?vue&type=script&lang=js&"
export * from "./VacancyUnavailableChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./VacancyUnavailableChatMessage.scss?vue&type=style&index=0&id=ee6678bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6678bc",
  null
  
)

export default component.exports